import React from 'react';
import { PlainPageHeadingContext } from 'components/plain_page_heading';
import { observer } from 'mobx-react';
import { FaqItemShowWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import TextDisplay from 'components/text_display';
import FaqHeader, { FaqContentWrapper } from 'components/faq_header';
import Link from 'components/link';
import { AppUI, ForumUI } from '@seedlang/state';
import Spinner from 'components/spinner';
import { isPresent } from '@seedlang/utils';
import CommentCreate from 'components/comment/comment_create';
import CommentIndex from 'components/comment/comment_index';
import withRouteParams from 'utils/with_route_params';
import Button from 'components/button/button';

const Body = styled.div`
  background: #FFF;
  padding: ${props => props.embedded ? '0 20px 20px 0' : '20px'};
`;

const AdminLink = styled.div`
  width: 100%;
  text-align: center;
  font-size: 12px;
  text-decoration: underline;
`;

const CommentsWrapper = styled.div`
  padding: ${props => props.embedded ? '20px 20px 20px 0' : '20px'};
  background: #FFF;
  margin-top: 10px;
`;

const ErrorMessage = styled.div`
  text-align: center;
`;

@observer
class FaqItemShow extends React.Component {
  static contextType = PlainPageHeadingContext;

  render() {
    return (
      <FaqContentWrapper>
        <FaqHeader
          currentRoute='faq_items.show'
          title={this.props.faqItem.titleWithPublished}
          faqCategoryName={this.props.faqCategory?.name}
          faqCategoryId={this.props.params.faqCategoryId}
        />
        <Body embedded={this.context}>
          {
            this.props.isLoading &&
              <Spinner />
          }
          {
            !this.props.isLoading && this.props.loadFailed &&
              <ErrorMessage>
                <p>Sorry, we couldn&apos;t load this help article.</p>
                <Button onClick={this.props.retryLoad}>
                  Try Again
                </Button>
              </ErrorMessage>
          }
          {
            !this.props.loadFailed && isPresent(this.props.faqItem) && AppUI.siteIsSeedlang &&
              <TextDisplay
                removeTopMargin={this.context}
                markdown={this.props.faqItem.body || ''}
              />
          }
          {
            !this.props.loadFailed && isPresent(this.props.faqItem) && AppUI.siteIsMemrev &&
              <div
                className='faq-item-content'
                dangerouslySetInnerHTML={{ __html: this.props.faqItem.body || '' }}
              />
          }
        </Body>
        {
          isPresent(this.props.faqItem) &&
          <CommentsWrapper embedded={this.context}>
            <CommentCreate
              namespace={this.props.faqItem.id}
              commentable={ForumUI.forumThread}
              commentableType='ForumThread'
              afterCreateComment={this.props.afterCreateComment}
              faqItemId={this.props.faqItem.id}
            />
            {
              this.props.showSpinner &&
                <Spinner
                  className='blue'
                />
            }
            {
              !this.props.showSpinner &&
                <CommentIndex
                  languageId='DE'
                  showCommentCount
                  indentation={20}
                  user={AppUI.user}
                  onChange={this.props.afterEmbeddedCommentCreate}
                  commentable={this.props.forumThread}
                  commentableType='ForumThread'
                  forumThreadId={this.props.forumThread?.id}
                  commentMargin='0'
                  margin={this.props.commentMargin}
                  padding='0'
                />
            }
          </CommentsWrapper>
        }
        {
          AppUI.user.admin &&
            <AdminLink>
              <Link
                to={{
                  name: AppUI.siteIsSeedlang ? 'builder.faq_items.edit' : 'creator.faq_items.edit',
                  params: {faqCategoryId: this.props.params.faqCategoryId, faqItemId: this.props.params.faqItemId},
                }}
              >
                Admin Link
              </Link>
            </AdminLink>
        }
      </FaqContentWrapper>
    );
  }
}

export default withRouteParams(FaqItemShowWrapper(FaqItemShow));
